import '../scss/main.scss';

import Nav from './components/Nav';
import LoadImage from './components/LoadImage';
import Accordion from './components/Accordion';
import Counter from './components/Counter';
import FadeIn from './components/FadeIn';
import IsDraggable from './components/IsDraggable';
import HideOnScroll from './components/HideOnScroll';
import Carousel from './components/Carousel';
import VideoPlayer from './components/VideoPlayer';
// import heroImgAnimation from './components/heroImgAnimation';
import profileOverlay from './components/profileOverlay';
import './react/agenda';
import RenderTiles from './react/agenda';


// document.addEventListener("DOMContentLoaded", () => document.body.classList.remove('loading'));


document.querySelectorAll('.js-nav')?.forEach((el) => {
	new Nav(el);
});

// document.querySelectorAll('.hero__animation--js').forEach((el) => {
// 	new heroImgAnimation(el);
// });

document.querySelectorAll('.js-profile-overlay')?.forEach((el) => {
	new profileOverlay(el);
}
);

document.querySelectorAll('.js-load-image').forEach((el) => {
	new LoadImage(el);
});

document.querySelectorAll('.js-accordion').forEach((el) => {
	new Accordion(el);
});

document.querySelectorAll('.js-counter').forEach((el) => {
	new Counter(el);
});

document.querySelectorAll('.js-fade-in').forEach((el) => {
	new FadeIn(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
	new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
	new HideOnScroll(el);
});

document.querySelectorAll('.js-carousel').forEach((el) => {
	new Carousel(el);
});

document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
});

console.log('test');
